import { useEffect, useRef, useState } from 'react';
import { isArr, isValid } from '@formily/shared';
const calcBreakpointIndex = (breakpoints, width) => {
    for (let i = 0; i < breakpoints.length; i++) {
        if (width <= breakpoints[i]) {
            return i;
        }
    }
    return 0;
};
const calcFactor = (value, breakpointIndex) => {
    if (Array.isArray(value)) {
        if (breakpointIndex === -1)
            return value[0];
        return value[breakpointIndex] ?? value[value.length - 1];
    }
    else {
        return value;
    }
};
// eslint-disable-next-line
const factor = (value, breakpointIndex) => isValid(value) ? calcFactor(value, breakpointIndex) : value;
const calculateProps = (target, props) => {
    const { clientWidth } = target;
    const { breakpoints = [0], layout, labelAlign, wrapperAlign, labelCol, wrapperCol, ...otherProps } = props;
    const breakpointIndex = calcBreakpointIndex(breakpoints, clientWidth);
    return {
        layout: factor(layout, breakpointIndex),
        labelAlign: factor(labelAlign, breakpointIndex),
        wrapperAlign: factor(wrapperAlign, breakpointIndex),
        labelCol: factor(labelCol, breakpointIndex),
        wrapperCol: factor(wrapperCol, breakpointIndex),
        ...otherProps,
    };
};
export const useResponsiveFormLayout = (props) => {
    const ref = useRef(null);
    const { breakpoints } = props;
    if (!isArr(breakpoints)) {
        return { ref, props };
    }
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [layoutProps, setLayout] = useState(props);
    const updateUI = () => {
        if (ref.current) {
            setLayout(calculateProps(ref.current, props));
        }
    };
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const observer = () => {
            updateUI();
        };
        const resizeObserver = new ResizeObserver(observer);
        if (ref.current) {
            resizeObserver.observe(ref.current);
        }
        updateUI();
        return () => {
            resizeObserver.disconnect();
        };
    }, []);
    return {
        ref,
        props: layoutProps,
    };
};
